import { useState } from 'react';
import { useFeed } from '../hooks/useFeed';
import { useAuth } from '../context/AuthContext';

const EMOJIS = ['🥁','🎵','🍲','👗','💃','🌍','🦁','🌅','🎨','⚽','📸','🏺','🎤','🦒'];
const COUNTRIES = ['Uganda','Kenya','Nigeria','Ghana','Ethiopia','Tanzania','South Africa','Senegal','Rwanda','Cameroon','Other'];

export default function UploadModal({ onClose }) {
  const { createPost } = useFeed();
  const { profile } = useAuth();
  const [caption, setCaption] = useState('');
  const [emoji, setEmoji] = useState('🎬');
  const [tagsInput, setTagsInput] = useState('');
  const [country, setCountry] = useState(profile?.country || 'Uganda');
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);

  async function handlePost() {
    if (!caption.trim()) return;
    setLoading(true);
    try {
      const tags = tagsInput.split(',').map(t => t.trim().replace('#','')).filter(Boolean);
      await createPost({ caption, videoFile: file, thumbnailEmoji: emoji, tags, country });
      onClose();
    } finally { setLoading(false); }
  }

  return (
    <div onClick={e => e.target === e.currentTarget && onClose()} style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.7)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:100, padding:20 }}>
      <div style={{ background:'var(--earth)', border:'1px solid var(--border)', borderRadius:20, padding:28, width:'100%', maxWidth:440 }}>
        <h3 style={{ fontFamily:'Sora,sans-serif', fontSize:17, fontWeight:600, marginBottom:20, color:'var(--text)' }}>Create Post</h3>
        <div style={{ marginBottom:16 }}>
          <div style={{ fontSize:12, color:'var(--muted)', marginBottom:8 }}>Thumbnail</div>
          <div style={{ display:'flex', flexWrap:'wrap', gap:6 }}>
            {EMOJIS.map(e => (
              <button key={e} onClick={() => setEmoji(e)} style={{ width:36, height:36, fontSize:20, borderRadius:8, cursor:'pointer', border:'1px solid', borderColor: emoji===e ? 'var(--sunset)' : 'var(--border)', background: emoji===e ? 'rgba(232,168,56,0.1)' : 'transparent' }}>{e}</button>
            ))}
          </div>
        </div>
        <div style={{ marginBottom:14 }}>
          <div style={{ fontSize:12, color:'var(--muted)', marginBottom:6 }}>Video (optional)</div>
          <label style={{ display:'block', padding:16, border:'1px dashed var(--border)', borderRadius:10, textAlign:'center', cursor:'pointer', fontSize:13, color:'var(--muted)' }}>
            {file ? `✓ ${file.name}` : '+ Upload video'}
            <input type="file" accept="video/*" style={{ display:'none' }} onChange={e => setFile(e.target.files[0])} />
          </label>
        </div>
        <div style={{ marginBottom:14 }}>
          <div style={{ fontSize:12, color:'var(--muted)', marginBottom:6 }}>Caption *</div>
          <textarea value={caption} onChange={e => setCaption(e.target.value)} placeholder="What's happening in Africa? 🌍" rows={3} style={{ width:'100%', padding:'10px 12px', borderRadius:10, resize:'none', fontSize:14 }} />
        </div>
        <div style={{ marginBottom:14 }}>
          <div style={{ fontSize:12, color:'var(--muted)', marginBottom:6 }}>Tags (comma separated)</div>
          <input value={tagsInput} onChange={e => setTagsInput(e.target.value)} placeholder="Afrobeats, Uganda, Music" style={{ width:'100%', padding:'9px 12px', borderRadius:10, fontSize:14 }} />
        </div>
        <div style={{ marginBottom:20 }}>
          <div style={{ fontSize:12, color:'var(--muted)', marginBottom:6 }}>Country</div>
          <select value={country} onChange={e => setCountry(e.target.value)} style={{ width:'100%', padding:'9px 12px', borderRadius:10, fontSize:14 }}>
            {COUNTRIES.map(c => <option key={c}>{c}</option>)}
          </select>
        </div>
        <div style={{ display:'flex', gap:10 }}>
          <button onClick={onClose} style={{ flex:1, padding:12, borderRadius:30, background:'transparent', border:'1px solid var(--border)', color:'var(--text)', fontSize:14, cursor:'pointer' }}>Cancel</button>
          <button onClick={handlePost} disabled={loading || !caption.trim()} style={{ flex:1, padding:12, borderRadius:30, background:'linear-gradient(135deg, var(--sunset), var(--flame))', color:'white', border:'none', fontSize:14, cursor:'pointer' }}>
            {loading ? '...' : 'Post 🌍'}
          </button>
        </div>
      </div>
    </div>
  );
}
